var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLutron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 16,
    viewBox: "0 0 108 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lutron_black 1",
    clipPath: "url(#clip0_14952_5894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.5299 14.8468H54.184V4.10765H59.3987V1.23853H45.2964V4.10765H50.5299V14.8468Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.9956 7.90309C74.9956 11.9539 78.131 15.1964 83.4589 15.1917C88.7868 15.187 91.941 11.9539 91.941 7.90309C91.941 3.73884 88.8056 0.812988 83.4778 0.812988C78.1499 0.812988 75.0192 3.74829 75.0192 7.90309H74.9956ZM79.239 8.19142C79.239 5.73352 80.1443 3.56868 83.4306 3.53559C86.7169 3.5025 88.0842 5.67207 87.9003 8.12052C87.7212 10.3941 86.7122 12.3746 83.4306 12.3746C80.2527 12.3746 79.239 10.413 79.239 8.21033V8.19142Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M93.0161 14.8467H96.689V6.15892H96.7362L103.771 14.8467H108V1.21948L104.289 1.23839V10.0916H104.242L97.1982 1.23839H93.0161V14.8467Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8462 14.8561H29.3506V11.9586H21.5144V1.21948H17.8462V14.8561Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.4662 1.21948H40.8122V9.55272C40.8122 11.6372 39.6334 12.4597 36.9365 12.4597C34.2396 12.4597 33.075 11.6467 33.0797 9.55272V1.21948H29.4351V9.55272C29.4351 13.3672 32.3064 15.1917 36.9365 15.1917C41.5666 15.1917 44.4804 13.3483 44.4804 9.55272V1.21948H44.4662Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M60.1953 14.8468H63.5853V9.54811H69.0782C70.4927 9.52448 70.7615 10.224 70.9925 11.6751C71.2848 13.4666 71.5111 14.913 72.539 14.8468H75.4387C74.6088 15.0169 74.3637 12.6347 74.1892 11.5381C73.7177 8.53659 73.2132 8.39006 71.8317 8.33334V8.28607C73.5951 7.72359 74.7126 6.36229 74.6607 4.71266C74.6041 2.51945 73.0812 1.02108 69.5261 1.24323H60.1953V14.8468ZM63.5382 4.01783H68.0881C69.776 4.01783 70.95 4.25889 70.95 5.61546C70.95 6.97204 69.776 7.21783 68.0881 7.21783H63.5382V4.01783Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.58158 4.01773C7.71309 4.00279 7.8453 3.99491 7.97764 3.9941C8.11469 3.9949 8.2516 4.00279 8.38784 4.01773L8.7886 0.0425441C8.51921 0.0141073 8.24852 -9.25237e-05 7.97764 3.4413e-06C7.70832 -0.000254122 7.43919 0.0139464 7.17139 0.0425441L7.58158 4.01773Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.09169 4.47159C6.20485 4.41014 6.32743 4.35342 6.45002 4.30142C6.57632 4.24874 6.70539 4.20298 6.83665 4.16435L5.6862 0.335693C5.42856 0.413705 5.17518 0.505215 4.9271 0.609844C4.67805 0.709386 4.43414 0.821393 4.19629 0.945442L6.09169 4.47159Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.88939 5.46409C4.96954 5.36483 5.05913 5.26557 5.15343 5.16631C5.24773 5.06704 5.35617 4.97724 5.4599 4.89215L2.93741 1.79614C2.72996 1.96631 2.53193 2.15065 2.35748 2.36335C2.18303 2.57605 1.98028 2.75567 1.81055 2.96365L4.88939 5.46409Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.15371 6.84431C4.19615 6.71668 4.23858 6.59379 4.29045 6.46617C4.34231 6.33855 4.4036 6.21565 4.4649 6.09748L0.94285 4.20679C0.81591 4.44505 0.701034 4.68957 0.598661 4.93943C0.494293 5.18813 0.403012 5.44215 0.325195 5.70044L4.15371 6.84431Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4.00769 8.3995C3.99265 8.26609 3.98478 8.13198 3.98411 7.99772C3.98478 7.8619 3.99265 7.72621 4.00769 7.59123L0.0424377 7.18945C0.0139116 7.45792 -0.000253487 7.72773 3.4327e-06 7.99772C-9.22925e-05 8.26928 0.0140721 8.54066 0.0424377 8.81072L4.00769 8.3995Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M4.46052 9.89306C4.39922 9.7749 4.34265 9.65673 4.29078 9.52911C4.23892 9.40148 4.19177 9.27386 4.15405 9.14624L0.334961 10.2948C0.4104 10.5501 0.504698 10.8053 0.608426 11.0606C0.712155 11.3158 0.830028 11.5569 0.943186 11.8168L4.46052 9.89306Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M5.45028 11.0983C5.3497 11.0132 5.25069 10.9234 5.15324 10.8289C5.05895 10.7296 4.96465 10.6304 4.87978 10.5264L1.7915 13.0552C1.96124 13.2584 2.14512 13.4617 2.33843 13.6555C2.52931 13.8401 2.72915 14.0152 2.93723 14.1801L5.45028 11.0983Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.82722 11.8168C6.69991 11.779 6.57733 11.7318 6.45002 11.6845C6.32272 11.6372 6.20013 11.5711 6.08226 11.5049L4.19629 15.0263C4.43291 15.157 4.67693 15.2738 4.9271 15.3761C5.17525 15.4792 5.42863 15.5691 5.6862 15.6455L6.82722 11.8168Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.37841 11.9824C8.24491 11.9896 8.11113 11.9896 7.97764 11.9824C7.84257 11.9896 7.70722 11.9896 7.57215 11.9824L7.17139 15.9576C7.43919 15.9862 7.70832 16.0004 7.97764 16.0001C8.24852 16.0002 8.51921 15.986 8.7886 15.9576L8.37841 11.9824Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M9.86849 11.5237C9.75124 11.5895 9.62999 11.6479 9.50544 11.6986C9.37814 11.7506 9.25084 11.7931 9.12354 11.8356L10.2693 15.6596C10.5239 15.5839 10.7785 15.4941 11.0331 15.3902C11.2904 15.2867 11.5422 15.17 11.7875 15.0404L9.86849 11.5237Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.0705 10.531C10.9856 10.635 10.8961 10.7343 10.8018 10.8288C10.7058 10.9252 10.6051 11.0167 10.5 11.1029L13.0225 14.18C13.2252 14.0099 13.428 13.8303 13.6213 13.6365C13.8146 13.4427 13.9938 13.2394 14.1635 13.0362L11.0705 10.531Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M11.7873 9.15576C11.7495 9.27866 11.7024 9.40628 11.6552 9.52917C11.6081 9.65207 11.5421 9.77969 11.4761 9.90259L14.9887 11.7933C15.1172 11.5551 15.2337 11.3106 15.3376 11.0606C15.4413 10.8054 15.5309 10.5501 15.6063 10.2949L11.7873 9.15576Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M11.9521 7.60068C11.9592 7.73293 11.9592 7.86547 11.9521 7.99772C11.9592 8.13471 11.9592 8.27197 11.9521 8.40895L15.9174 8.81072C15.9458 8.54066 15.9599 8.26928 15.9598 7.99772C15.9601 7.72773 15.9459 7.45792 15.9174 7.18945L11.9521 7.60068Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M11.4951 6.10694C11.5608 6.22286 11.6191 6.34285 11.6696 6.46617C11.7214 6.59379 11.7639 6.72141 11.8063 6.85376L15.6207 5.70044C15.5445 5.44222 15.4548 5.1882 15.3519 4.93943C15.2499 4.68863 15.1334 4.44401 15.003 4.20679L11.4951 6.10694Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M10.5049 4.9015C10.6094 4.98334 10.7086 5.07175 10.8019 5.1662C10.9009 5.26546 10.9905 5.36945 11.0754 5.47344L14.1448 2.94463C13.9798 2.74248 13.8052 2.54846 13.6214 2.36324C13.4281 2.16945 13.2254 1.9851 13.0227 1.81494L10.5049 4.9015Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M9.13281 4.16435C9.2554 4.20689 9.3827 4.24943 9.50529 4.30142C9.62788 4.35342 9.75518 4.41487 9.87777 4.47631L11.7873 0.945442C11.5516 0.822547 11.3158 0.704379 11.0565 0.600391C10.7972 0.496402 10.5237 0.411321 10.2691 0.335693L9.13281 4.16435Z",
    fill: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14952_5894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLutron);
export default __webpack_public_path__ + "static/media/lutron.dd3d9c0d2e81784fb8fed255d2a9f134.svg";
export { ForwardRef as ReactComponent };